import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle"
export default class extends Controller {
  static targets = [ "toggler", "togglable" ]
  static values = {
    toggled: { type: Boolean, default: false },
    announcement: String
  }

  toggle() {
    this.toggleTogglables()
    this.announceToLiveRegion()
    this.toggledValue = !this.toggledValue
    this.togglerTarget.ariaExpanded = this.toggledValue
  }

  toggleTogglables() {
    this.togglableTargets.forEach(togglableTarget => {
      if (this.toggledValue) {
        togglableTarget.classList.add('d-none')
      } else {
        togglableTarget.classList.remove('d-none')
      }
    })
  }

  announceToLiveRegion() {
    const liveRegionContentElement = document.getElementById('live-region-content')
    liveRegionContentElement.textContent = this.announcementValue
    setTimeout(() => {liveRegionContentElement.textContent = ''}, 3000)
  }
}
